<script setup lang="ts">
const { modelValue } = defineProps<{
  modelValue: string;
}>();

const emit = defineEmits(["update:modelValue", "send"]);

const updateValue = (event: Event) => {
  emit("update:modelValue", event);
};
</script>

<template>
  <div class="chat-controls">
    <div class="bar">
      <div class="inner">
        <ChatInput
          class="input"
          :model-value="modelValue"
          @update:model-value="updateValue"
          @send="emit('send')"
        ></ChatInput>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chat-controls {
  position: relative;
  flex-shrink: 0;
  align-self: stretch;
  // box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: var(--main-body-background-color);
  justify-self: stretch;
  padding-bottom: env(safe-area-inset-bottom);
}

.bar {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  border-top: solid 1px rgba(0, 0, 0, 0.1);
  padding: 15px;
}

.inner {
  width: 100%;
  max-width: 1024px;
}

.v-enter-active,
.v-leave-active {
  transition:
    opacity 250ms ease,
    transform 250ms ease;
}

.v-enter-from,
.v-leave-to {
  transform: translateY(100%);
}
</style>
